export default __webpack_public_path__ + "notice-icon1db147.png";